export const ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT=`ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT`;
export const ORDER_PAYMENT_FETCHING=`ORDER_PAYMENT_FETCHING`;
export const ORDER_PAYMENT_ERROR=`ORDER_PAYMENT_FETCHING`;